<template>
  <div class="filter-post" id="filter-post" v-if="isEnable() && isReadyComponent()">
    <div class="filter-post__row">
      <div class="block">
        <div class="filter-post__search">
          <label class="form-label">Поисковый запрос</label>
          <div class="input-group">
            <span class="input-group-text">
              <input class="form-check-input m-0" @change="events.onSearch" type="checkbox" v-model="bootData.search_full_match" title="Точное совпадение">
            </span>
            <div class="input-icon">
              <input @keyup.enter="events.onSearch" type="text" v-model="bootData.search" class="form-control" placeholder="Напишите что-нибудь">
              <button class="btn input-icon-addon__button" @click="events.onSearch">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <circle cx="10" cy="10" r="7" />
                  <line x1="21" y1="21" x2="15" y2="15" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="block">
        <div class="filter-post__date">
          <label class="form-label">Дата публикации</label>
          <Datepicker auto-apply v-model="bootData.date" @update:modelValue="events.applyDate" range multi-calendars locale="ru" format="dd.MM.yyyy" placeholder="Выбрать дату" :enable-time-picker="false" />
        </div>
      </div>

      <div class="block">
        <div class="filter-post__select users">
          <label class="form-label">Пользователь</label>
          <Multiselect @change="events.onUser" v-model="bootData.users" mode="tags" placeholder="Не выбрано" noResultsText="Результатов не найдено" :close-on-select="true" :options="variantsData.users" :searchable="true" :trackBy="'name'">
            <template v-slot:tag="{ option, handleTagRemove, disabled }">
              <div class="multiselect-tag element" :class="{ 'is-disabled': disabled }">
                <img :src="option.image">
                <div class="user-name">{{ option.name }}</div>
                <span v-if="!disabled" class="multiselect-tag-remove" @mousedown.prevent="handleTagRemove(option, $event)">
                  <span class="multiselect-tag-remove-icon"></span>
                </span>
              </div>
            </template>
            <template v-slot:option="{ option }">
              <div class="option-user">
                <div class="user-image-wrap">
                  <img class="user-image" :src="option.image">
                </div>
                <div class="user-name"> {{ option.name }}</div>
              </div>
            </template>
          </Multiselect>
        </div>
      </div>

      <div class="block">
        <div class="filter-post__select types-commerce">
          <label class="form-label">Тип</label>
          <Multiselect @change="events.onTypesCommerce" v-model="bootData.typesCommerce" mode="tags" placeholder="Нет" noResultsText="Результатов не найдено" :close-on-select="true" :options="variantsData.typesCommerce">
            <template v-slot:tag="{ option, handleTagRemove, disabled }">
              <div class="multiselect-tag element" :class="{ 'is-disabled': disabled }">
                <div class="user-name">{{ option.name }}</div>
                <span v-if="!disabled" class="multiselect-tag-remove" @mousedown.prevent="handleTagRemove(option, $event)">
                  <span class="multiselect-tag-remove-icon"></span>
                </span>
              </div>
            </template>
            <template v-slot:option="{ option }">
              <div class="option-user">
                <div class="user-name"> {{ option.name }}</div>
              </div>
            </template>
          </Multiselect>
        </div>
      </div>

      <div class="block">
        <div class="filter-post__buttons">
          <label class="form-label">Статус</label>
          <div class="form-selectgroup">
            <label class="form-selectgroup-item">
              <input @change="events.onStatuses" type="checkbox" v-model="bootData.statuses.published" class="form-selectgroup-input">
              <span class="form-selectgroup-label">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-sun me-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <circle cx="12" cy="12" r="4"></circle>
                  <path d="M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"></path>
                </svg>
                <template v-if="isChannelSite()">
                  Включено
                </template>
                <template v-else>
                  Активно
                </template>
              </span>
            </label>
            <label class="form-selectgroup-item">
              <input @change="events.onStatuses" type="checkbox" v-model="bootData.statuses.scheduled" class="form-selectgroup-input">
              <span class="form-selectgroup-label">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-calendar-event me-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <rect x="4" y="5" width="16" height="16" rx="2"></rect>
                  <line x1="16" y1="3" x2="16" y2="7"></line>
                  <line x1="8" y1="3" x2="8" y2="7"></line>
                  <line x1="4" y1="11" x2="20" y2="11"></line>
                  <rect x="8" y="15" width="2" height="2"></rect>
                </svg>
                Отложено
              </span>
            </label>
            <label class="form-selectgroup-item">
              <input @change="events.onStatuses" type="checkbox" v-model="bootData.statuses.removed" class="form-selectgroup-input">
              <span class="form-selectgroup-label">
                <template v-if="isChannelTelegram()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-trash me-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <line x1="4" y1="7" x2="20" y2="7"></line>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                  </svg>
                </template>
                <template v-if="isChannelSite()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                       class="icon icon-tabler icons-tabler-outline icon-tabler-bulb-off me-1"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path
                      d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"/><path
                      d="M11.089 7.083a5 5 0 0 1 5.826 5.84m-1.378 2.611a5.012 5.012 0 0 1 -.537 .466a3.5 3.5 0 0 0 -1 3a2 2 0 1 1 -4 0a3.5 3.5 0 0 0 -1 -3a5 5 0 0 1 -.528 -7.544"/><path
                      d="M9.7 17h4.6"/><path d="M3 3l18 18"/>
                  </svg>
                </template>
                <template v-if="isChannelSite()">
                  Выключено
                </template>
                <template v-else>
                  Удалено/Выключено
                </template>
              </span>
            </label>
            <label class="form-selectgroup-item">
              <div class="show-options" @click="showOptions()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-caret-up-down">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M18 10l-6 -6l-6 6h12" />
                  <path d="M18 14l-6 6l-6 -6h12" />
                </svg>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-post__options" v-show="isShowOptions()">
      <div class="filter-post__row">
        <div class="block">
          <div class="filter-post__shops">
            <Shops :data="{
               val: bootData.shops,
            }" @onChange="events.onShops"/>
          </div>
        </div>

        <div class="block">
          <div class="filter-post__categories">
            <Category :data="{
              val: [0],
            }" @onChange="events.onCategories"/>
          </div>
        </div>

        <div class="block">
          <div class="filter-post__type-visible">
            <TypeVisible :data="{
              val: bootData.type_visibility,
            }" @onChange="events.onTypeVisible"/>
          </div>
        </div>

        <div class="block">
          <div class="filter-post__is-moderate">
            <IsModerate :data="{
              val: bootData.is_moderate,
            }" @onChange="events.onIsModerate"/>
          </div>
        </div>

        <template v-if="isChannelSite()">
          <div class="block">
            <div class="filter-post__type_id">
              <TypeId :data="{
                 val: bootData.type_id,
              }" @onChange="events.onTypeId"/>
            </div>
          </div>
        </template>

        <template v-if="isChannelSite()">
          <div class="block">
            <div class="filter-post__promocode">
              <Promocode :data="{
                val: bootData.promocode,
              }" @onChange="events.onPromocode"/>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, reactive, watch} from "vue"
import Multiselect from "@/plugins/multiselect"
import Datepicker from "@/plugins/datepicker"
import Shops from "@/modules/post/components/filter/components/shops/Index"
import Category from "@/modules/post/components/filter/components/category/Index"
import TypeVisible from "@/modules/post/components/filter/components/type_visible/Index"
import { useFilter } from './Filter.js'
import IsModerate from "@/modules/post/components/filter/components/is_moderate/Index.vue"
import Helper from "@/services/Helper"
import TypeId from "@/modules/post/components/filter/components/type_id/Index"
import Promocode from "@/modules/post/components/filter/components/promocode/Index"

export default defineComponent({
  name: "Filter",
  components: {
    IsModerate,
    Shops,
    Category,
    TypeVisible,
    Datepicker,
    Multiselect,
    TypeId,
    Promocode,
  },
  props: {
    enable: {
      type: Boolean,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    const {
      events,
      bootData,
      variantsData,
      isEnable,
      isReadyComponent,
      showOptions,
      isShowOptions,
    } = useFilter(props, {emit})

    let fields = reactive(getFields())

    watch(() => props.payload, () => {
      updateFields(props.payload)
    }, { immediate: true })

    async function updateFields(query) {
      fields.channel_id = query.channel_id
    }

    function getFields() {
      return {
        channel_id: null,
      }
    }

    function isChannelSite() {
      let channelId = parseInt(fields.channel_id)
      return Helper.inArray([channelId], [1])
    }

    function isChannelTelegram() {
      let channelId = parseInt(fields.channel_id)
      return Helper.inArray([channelId], [2,3,4,5,6,7,8,9,10,11,12])
    }

    return {
      events,
      bootData,
      variantsData,
      isEnable,
      isReadyComponent,
      showOptions,
      isShowOptions,
      fields,
      isChannelSite,
      isChannelTelegram,
    }
  }
})
</script>

<style scoped></style>
